import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import template from '@bingads-webui-campaign-legacy/ad-schedule/template/index.pug';
import ViewModel from '@bingads-webui-campaign-legacy/ad-schedule/viewmodel/index';
import DateSettings from '@bingads-webui-campaign-legacy/ad-schedule/view/date-settings';
import adSchedulingOptions from '@bingads-webui-campaign-legacy/ad-schedule/viewmodel/options';
import ToggleView from '@bingads-webui-component-legacy/toggle/view/index';
import config from '@bingads-webui-component-legacy/config/index';
import timeZoneMapper from '@bingads-webui-component-legacy/timezonemapper/index';
import { isCampaignApiError } from '@bingads-webui-component-legacy/api-errors-campaign/index';
import { getRealCashbackPercentValue } from '@bingads-webui-campaign/target-bid-adjustment';
import pageContext from '@bingads-webui-static-legacy/page-context';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

const defaultOptions = {
  template,
  showDateSettings: true,
  fromSettingsGrid: false,
  showBidAdjustmentColumn: true,
  showDisplayTimeAndFooter: true,
  hideWarning: false,
  hideUseCampaignSetting: false,
  hideMinuteOptions: false,
};

const defaultPopupIds = {
  AdSchedule: 'pop_BA_Targeting_DayTime',
  BidAdjustment: 'Page_TargetByDayTime_BidAdjustment',
  TimeZone: 'pop_BA_Targeting_TimeZone',
};

const defaulti18nKeys = {
  Warning: 'TargetingSettings_AdSchedule_Warning',
};

export default class View extends Backbone.View {
  initialize(options = {}) {
    const isMSANBoostEnabled = pageContext.Permissions.IsAmplifyEnabled;

    this.options = _.defaults(options, defaultOptions);
    this.model.timeZoneText = timeZoneMapper.getAccountTimeZoneText();
    this.model.adScheduleUseSearcherTimeZone = _.isBoolean(this.model.adScheduleUseSearcherTimeZone) ?
      this.model.adScheduleUseSearcherTimeZone : false;
    this.model.adScheduleTimeZoneSetting = this.model.adScheduleTimeZoneSetting || 0;
    this.model.campaignAdScheduleUseSearcherTimeZone = _.isBoolean(this.options.campaignAdScheduleUseSearcherTimeZone) ?
      this.options.campaignAdScheduleUseSearcherTimeZone : false;
    this.supportCashbackSettings = !!options.supportCashbackSettings && !pageContext.Permissions.IsPersonalizedOffersV3Enabled;
    this.isHideBidAdjustmentForBoostEnabled = isMSANBoostEnabled && pageContext.Permissions.dynamic && pageContext.Permissions.dynamic.HideBidAdjustmentForBoost;
    this.popupIds = _.defaults({}, options.popupIds, defaultPopupIds);
    this.i18nKeys = _.defaults({}, options.i18nKeys, defaulti18nKeys);

    this.koModel = new ViewModel(
      this.model,
      this.options.level,
      this.options.campaignDayTimeRanges,
      this.options.isForVNext,
      this.options.activityLogger,
      this.supportCashbackSettings,
      options.currentCampaign,
      options.currentAdGroup,
      options.hideAdScheduleBidAdjustments,
      options.readOnlyTimeZone,
      this.options.hideWarning,
      this.options.hideUseCampaignSetting,
      _.bind(this.callOnChangeCb, this),
    );

    if (this.options.showDateSettings) {
      this.dateSettings = new DateSettings(_.extend(
        {
          activityLogger: options.activityLogger,
          callOnChangeCb: _.bind(this.callOnChangeCb, this),
        },
        _.pick(this.model, 'startDate', 'endDate', 'adGroupStatus', 'timeZone'),
      ));
    }

    this.toggleView = new ToggleView({
      toggleText: {
        // #TOGGLEBUG These keys were missing in the old system
        // In the new i18n system, On/Off text unexpectedly appears in the UI
        on: undefined, // i18n.getString('Toggle_On'),
        off: undefined,  // i18n.getString('Toggle_Off'),
      },
      labelledbyId: 'ad-schedule-use-campaign-settings',
    });
    this.toggleView.setToggleState(this.koModel.useCampaignSettingsChecked() ? 'on' : 'off');
    this.listenTo(this.toggleView, 'change', (toggleState) => {
      this.koModel.useCampaignSettingsChecked(toggleState === 'on');
    }, this);

    this.koModel.useCampaignSettings.subscribe((checked) => {
      if (!checked && _.isEmpty(this.model.dayTimeRanges) && !_.isEmpty(this.options.campaignDayTimeRanges)) {
        this.koModel.update({
          dayTimeRanges: this.options.campaignDayTimeRanges,
        });
      }
      this.koModel.showAdGroupOverrideInformation(false);
      this.koModel.adScheduleUseSearcherTimeZone(checked ? this.model.campaignAdScheduleUseSearcherTimeZone : this.model.adScheduleUseSearcherTimeZone);
      this.callOnChangeCb();
    }, this);

    this.koModel.showAdGroupOverrideInformation(this.options.fromSettingsGrid && this.koModel.useCampaignSettings());

    this.koModel.dayTimeRanges.subscribe(() => {
      this.callOnChangeCb();
    });
  }

  toggleCashbackPercentColumns(supportCashbackSettings, inheritInfo) {
    this.koModel.supportCashbackSettings(supportCashbackSettings && !pageContext.Permissions.IsPersonalizedOffersV3Enabled);
    this.koModel.resetCashbackInheritStatus(inheritInfo);
  }

  render() {
    const { showBidAdjustmentColumn, showDisplayTimeAndFooter, hideMinuteOptions } = this.options;

    this.$el.html(this.options.template({
      percentSymbol: config.get('globalization.number.percentSymbol'),
      i18n,
      i18nKeys: this.i18nKeys,
      showDateSettings: this.options.showDateSettings,
      showBidAdjustmentColumn: showBidAdjustmentColumn && !this.isHideBidAdjustmentForBoostEnabled,
      hideMinuteOptions,
      showDisplayTimeAndFooter,
      popupIds: this.popupIds,
    }));

    ko.applyBindings(this.koModel, this.el);

    if (this.options.showDateSettings) {
      this.$('.date-settings__container').append(this.dateSettings.render().el);
    }

    this.toggleView.render();
    this.$('.toggle-campaign-settings-switch').append(this.toggleView.el);

    return this;
  }

  log(mes) {
    if (this.options.activityLogger) {
      this.options.activityLogger.signal(mes, 'ad schedule');
    }
  }

  get events() {
    return {
      'click .add-time-row': 'addTimeRow',
      'click .remove-all-row': 'removeAllRows',
      'click .remove-schedule': 'removeRow',
    };
  }

  addTimeRow() {
    this.koModel.addTimeRow();
    this.log('add schedule row clicked');
  }

  removeAllRows() {
    this.koModel.dayTimeRanges([]);
    this.log('remove all schedule rows clicked');
  }

  removeRow(event) {
    const index = parseInt($(event.target).attr('data-index'));

    this.koModel.onRemovingSchedulingRow(index);

    // needed by feeds
    event.stopImmediatePropagation();
    this.log('remove a schedule row clicked');
  }

  callOnChangeCb() {
    if (_.isFunction(this.options.onChange)) {
      this.options.onChange(this.getValues(this.options.deleteCb), this.validate());
    }
  }

  getValues(deleteCb) {
    let
      deletedItems = this.getDeletedItems(),
      items = this.getCriterions(),
      excluded = [];

    if (_.isFunction(deleteCb)) {
      deleteCb(deletedItems);
    }

    _.each(deletedItems, (deletedItem) => {
      _.each(items, (item) => {
        if (_.isEqual(_.omit(item.Criterion.DayTimeCriterion, 'Id'), _.omit(deletedItem.Criterion.DayTimeCriterion, 'Id'))) {
          const isBidAdjustmentUnchanged = item.Criterion.BidAdjustment === deletedItem.Criterion.BidAdjustment;
          const isCashbackPercentUnchanged = this.supportCashbackSettings ?
            getRealCashbackPercentValue(item.Criterion.CashbackPercent) === getRealCashbackPercentValue(deletedItem.Criterion.CashbackPercent) :
            true;

          if (isBidAdjustmentUnchanged && isCashbackPercentUnchanged) {
            excluded.push(item, deletedItem);
          } else {
            item.Id = deletedItem.Id;
            excluded.push(deletedItem);
          }
        }
      });
    });

    return _.difference(items.concat(deletedItems), excluded);
  }

  getCriterions() {
    const criterions = this.koModel.getCriterions();

    return this.formatCriterions(criterions);
  }

  getDateSettings() {
    return this.options.showDateSettings ? this.dateSettings.getValues() : {};
  }

  getDeletedItems() {
    let criterions = this.koModel.getDeletedItems();

    return this.formatCriterions(criterions);
  }

  getPropertyValidationErrors() {
    const dayTimeRanges = this.koModel.dayTimeRanges();
    const scheduleRowErrors = dayTimeRanges.map((range) => {
      const error = range().scheduleInRowError();

      return error ? error.message : null;
    }).filter((err) => err != null && err !== '');

    const dateErrors = [this.dateSettings.viewModel.startDateError(), this.dateSettings.viewModel.endDateError()]
      .filter((err) => err != null && err !== '');

    return {
      scheduleRow: scheduleRowErrors,
      date: dateErrors,
    };
  }

  validate() {
    return _.reduce([
      this.koModel.validate(),
      this.options.showDateSettings ? this.dateSettings.validate() : true,
    ], (memo, val) => {
      return memo && val;
    }, true);
  }

  getAdScheduleUseSearcherTimeZone() {
    return this.koModel.adScheduleUseSearcherTimeZone();
  }

  backFillItems(response) {
    //back fill the created items
    const criterions = response.entity.AdGroupCriterions ?
      response.entity.AdGroupCriterions :
      response.entity.CampaignCriterions;
    const deletedIds = _.chain(criterions)
      .where({
        CriterionType: 'DayTime',
        Status: 'Deleted',
      })
      .map((criterion) => {
        return criterion.Id;
      })
      .value();
    let added = _.chain(criterions)
      .filter((criterion) => {
        return criterion.CriterionType === 'DayTime' && criterion.Status !== 'Deleted';
      })
      .map((criterion) => {
        return {
          Id: criterion.Id,
          Day: criterion.Criterion.DayTimeCriterion.Day,
          StartHour: criterion.Criterion.DayTimeCriterion.FromHour,
          EndHour: criterion.Criterion.DayTimeCriterion.ToHour,
          StartMinute: adSchedulingOptions.minuteToReadMap[criterion.Criterion.DayTimeCriterion.FromMinute],
          EndMinute: adSchedulingOptions.minuteToReadMap[criterion.Criterion.DayTimeCriterion.ToMinute],
          BidAdjustmentType: criterion.Criterion.BidAdjustment >= 0 ? 1 : -1,
          BidAdjustmentAmount: window.Math.abs(criterion.Criterion.BidAdjustment),
        };
      })
      .value();

    // clone original model
    const originModel = $.extend(true, {}, this.koModel.model);

    // Ad group will change model.dayTimeRanges before updating to the MT, backfill the ids.
    if (response.entity.AdGroupCriterions) {
      _.each(originModel.dayTimeRanges, (r) => {
        const found = _.find(added, (range) => {
          const rangeWithoutId = { ...range };

          delete rangeWithoutId.Id;
          // should miss only the Id
          return _.isMatch(r, rangeWithoutId) && !_.isMatch(r, range);
        });

        if (found) {
          r.Id = found.Id;
        }
      });
    }

    added = _.filter(added, (range) => !_.find(originModel.dayTimeRanges, (r) => {
      return _.isMatch(r, range);
    }));

    let dayTimeRanges = _.filter(originModel.dayTimeRanges.concat(added), (range) => {
      return _.indexOf(deletedIds, range.Id.toString()) === -1;
    });

    const model = { dayTimeRanges };

    this.koModel.update(model);

    return criterions;
  }

  handleErrors(response) {
    const criterions = this.backFillItems(response);
    const schedulingEntities = _.where(criterions, { CriterionType: 'DayTime' });
    let schedulingErrors = [];

    _.each(schedulingEntities, (schedulingEntity) => {
      if (schedulingEntity.errors) {
        schedulingErrors = schedulingErrors.concat(schedulingEntity.errors);
      }
    });

    this.koModel.errors.add(schedulingErrors);

    response.errors = _.filter(response.errors, (error) => {
      return error.Type.indexOf('Day Time Criterion') === -1;
    });

    return response.errors;
  }

  clearApiErrors() {
    this.koModel.errors.clear(isCampaignApiError);
  }

  formatCriterions(criterions) {
    return _.map(criterions, (criterion) => {
      return {
        Criterion: criterion,
        CriterionType: 'DayTime',
        Id: criterion.DayTimeCriterion.Id,
      };
    });
  }

  remove(...args) {
    if (this.toggleView) {
      this.toggleView.remove();
    }
    super.remove(...args);
  }
}
